import React, { createElement, useState } from 'react'
import moduleCss from './index.module.scss'
import { Swiper } from 'swiper/esm/react/swiper.js'
import { SwiperSlide } from 'swiper/esm/react/swiper-slide.js'
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper'
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss'
import md5 from 'md5';
import TextInfo_skin0 from "./TextInfo_skin0";
import TextInfo_skin1 from "./TextInfo_skin1";
import TextInfo_skin2 from "./TextInfo_skin2";
import TextInfo_skin3 from "./TextInfo_skin3";
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import { getThumbnailFromRecommend } from '@ifeng/lowcode_tool/src/method/common'
import { formatImage } from '@ifeng/public_method'
import Chip from 'Chip';

SwiperCore.use([ Navigation, Pagination, Autoplay ])

export interface Swiper_1_Props {
    style?: object,
    swiperChip: TYPE_Chip
    height?: number // 轮播图高度
    loop: boolean // 是否循环

    // nav
    isHasNav: boolean // 是否有nav
    leftNavImage?: string // 左侧nav的图片
    leftNavHoverImage?: string // 左侧nav hover 时的图片
    rightNavImage?: string // 右侧nav的图片
    rightNavHoverImage?: string // 右侧nav hover的图片
    navWidth?: string
    navHeight?: string
    navY?: number
    navX?: number

    // 自动播放
    isAutoPlay: boolean // 是否开启自动播放
    autoSpeed: number // 自动播放的速度

    skin: number
    __designMode: string
}

const Swiper_1: React.FC<Swiper_1_Props> = (props) => {
    let { swiperChip, style, height, loop, isHasNav, leftNavImage, leftNavHoverImage, rightNavImage, rightNavHoverImage, navWidth, navHeight, navY, navX, isAutoPlay, autoSpeed, skin, __designMode } = props

    const [ swiperIndex, setSwiperIndex ] = useState(0) // swiper 内部的 index
    const [ isHoverLeft, setIsHoverLeft ] = useState(false)
    const [ isHoverRight, setIsHoverRight ] = useState(false)

    const swiperChipData = useChip(swiperChip)
    const swiperChipComponentData = formatChip(swiperChip)

    const getKey = () => {
        return md5(JSON.stringify({ isAutoPlay, autoSpeed }));
    };

    const GetTextInfo = () => {
        switch (skin) {
            case 0: {
                return <TextInfo_skin0 swiperIndex={swiperIndex} title={swiperChipData[swiperIndex].title} summary={swiperChipData[swiperIndex].summary} />
            }
            case 1: {
                return <TextInfo_skin1 title={swiperChipData[swiperIndex].title} url={swiperChipData[swiperIndex].url} />
            }
            case 2: {
                return <TextInfo_skin2 title={swiperChipData[swiperIndex].title} />
            }
            case 3: {
                return <TextInfo_skin3 title={swiperChipData[swiperIndex].title} />
            }
            default: return null
        }
    }

    return (
        <Chip {...swiperChipComponentData}>
            <div className={moduleCss.swiperWp} style={{  ...style }}>
                <Swiper
                    key={getKey()}
                    simulateTouch={__designMode !== 'design'}
                    loop={loop}
                    autoplay={isAutoPlay ? { delay: autoSpeed, disableOnInteraction: false } : false }
                    navigation={isHasNav ? { prevEl: `.${moduleCss.prev}`, nextEl: `.${moduleCss.next}` } : false}
                    pagination={[1, 3].includes(skin) ? { el: `.${moduleCss.pagination}` } : false }
                    onSlideChange={(swiper) => {
                        setSwiperIndex(swiper.realIndex)
                    }}
                    style={{ height }}
                >
                    {
                        swiperChipData && swiperChipData.map((item, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <div className={moduleCss.swiperItem}>
                                        <a href={item.url} target="_blank" rel="noreferrer">
                                            <img src={formatImage(getThumbnailFromRecommend(item), undefined, height * 2)} alt={item.name} />
                                        </a>
                                    </div>
                                </SwiperSlide>
                            );
                        })
                    }
                </Swiper>
                {
                    isHasNav &&
                    <React.Fragment>
                        <img style={{ width: `${navWidth}px`, height: `${navHeight}px`, top: `${navY}px`, left: `${navX}px` }} className={moduleCss.prev} src={isHoverLeft ? leftNavHoverImage || leftNavImage : leftNavImage} alt="" onMouseEnter={() => setIsHoverLeft(true)} onMouseLeave={() => setIsHoverLeft(false)} />
                        <img style={{ width: `${navWidth}px`, height: `${navHeight}px`, top: `${navY}px`, right: `${navX}px` }} className={moduleCss.next} src={isHoverRight ? rightNavHoverImage || rightNavImage : rightNavImage} alt="" onMouseEnter={() => setIsHoverRight(true)} onMouseLeave={() => setIsHoverRight(false)} />
                    </React.Fragment>
                }
                {
                    [1, 3].includes(skin) && <div className={`${moduleCss.pagination} ${moduleCss[`skin${skin}`]}`} />
                }
                {
                    swiperChipData && swiperChipData[swiperIndex] && GetTextInfo()
                }
                <Mask visible={!swiperChip.id} zIndex={3}>
                    示例推荐位碎片—{swiperChip.default.id}
                </Mask>
            </div>
        </Chip>
    )
}

Swiper_1.displayName = '轮播图_1'

export default Swiper_1;
